// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
const assign = require('lodash/assign');

const provideRequireCompat = function (moduleExport) {
  const defaultExport = moduleExport.default;
  assign(defaultExport, moduleExport);
  delete defaultExport.default;
  return defaultExport;
};

module.exports = provideRequireCompat;
